import IconArrowRight from '../../../../assets/icons/wideArrowRight.svg?react'
import IconArrowLeft from '../../../../assets/icons/wideArrowLeft.svg?react'
import css from './controls.module.css'

interface IProps {
  onClick: () => void
  prev?: boolean
  disabled?: boolean
}

const Control = (props: IProps) => {
  const renderControl = () => {
    if (props.disabled) return null

    if (props.prev) {
      return <IconArrowLeft className={css.iconArrow} />
    }
    return <IconArrowRight className={css.iconArrow} />
  }

  return (
    <div className={css.wrapper} onClick={props.onClick} data-disabled={props.disabled}>
      {renderControl()}
    </div>
  )
}

export default Control
